<div class="slider-container">
  <div class="items-container" #itemsContainer>
    <div class="item" *ngFor="let item of allItems">
      <img src="/assets/images/common/ok.svg" alt="Ok Icon">
      <div [innerHTML]="item | i18n"></div>
    </div>
  </div>
</div>
